export default __webpack_public_path__ + "static/icons-5208e2fd4f4a932f6ca53a99a209bc47.svg";